import { Typography, Icons} from '@hmsexp/component-library';
import React, { useCallback } from 'react';
import { View } from 'react-native';
import GridLayout from '../../../../components/GridLayout';
import { onlineReviewCompStyling } from './styles';
import SentimentChart from './components/SentimentChart';
import { useSelector } from 'react-redux';
import OverviewLoader from '../../../Overview/components/OverviewComp/OverviewLoader';
import LowerSampleSizeFooter from '../../../../components/Common/LowerSampleSizeFooter';
import ScoreOverTime from './components/ScoreOverTime';
import MultiFeatureCard from '../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import OnlineReviewByProperties from './components/OnlineReviewByProperties';
import ReviewRatings from './components/ReviewRatings';
import ScoreBySource from './components/ScoreBySource';
import ReviewTopicPlot from '../../../Overview/components/OverviewComp/components/ReviewTopicPlot';
import { OVERVIEW_WIDGET_DATA } from '../../constants';
import { useHistory } from 'react-router-dom';
import get from 'lodash/get';
import PieChartWidget from '../../../../components/Common/WidgetsCards/PieChartWidget';
import { getChartExportsMenuItems } from '../../../../utils/common';

const OverviewComp = () => {
  const styles = onlineReviewCompStyling();
  const history = useHistory();
  const {
    isFetchingOnlineReviewData,
    OnlineReviewData = [],
    OverviewDataFetchingError
  } = useSelector(e => e.fetchOnlineReviewDataReducer);
  const { filtersLoading, applied_filter_values, applied_filters } = useSelector(e => e.filterReducer);
  const timeperiodLabel = get(applied_filters, 'timePeriod[0].fullLabel', 'Last 90 days');

  function pieChartTooptip(scoreSize) {
    return (
      <View style={styles.pieChartContainer}>
        <Typography textProps={{ style: styles.tooltipValue }} variant='button' color='white'>
          {scoreSize}
        </Typography>
        <Typography textProps={{ style: styles.tooltipLabel }} variant='button' color='white'>
          {timeperiodLabel}
        </Typography>
      </View>
    );
  }
  function onTopicClick(e) {
    const appliedFilterValues = { ...applied_filter_values, topics_filter: [[e]] };
    const stringified = encodeURIComponent(JSON.stringify(appliedFilterValues));
    history.push(`/dashboard/feedback?filters=${stringified}`);
  }

  const renderItem = useCallback(({ item }) => {
    switch (item.type) {
      case 'TEXT_HEADER':
        return <Typography {...get(item, 'data.typographyProps')}>{get(item, 'data.title')}</Typography>;
      case 'PIE_CHART':
        return <PieChartWidget actionMenuData={getChartExportsMenuItems(item)} item={item} timeperiodLabel={timeperiodLabel} />;
      case 'REVIEW_VOLUME':
        return (
          <MultiFeatureCard
            title={item?.title}
            subTitle={timeperiodLabel}
            style={{ childContainer: { margin: 'auto' } }}
            enableActionBtn={get(item, 'enableActionBtn', false)}
            enableSwitchTab={get(item, 'enableSwitchTab', false)}
            switchOptions={get(item, 'switchOptions', [])}
            renderContent={() => {
              return (
                <View style={{ alignItems: 'center', justifyContent: 'center', flex: 1 }}>
                  <Typography variant='button' fontWeightType='regualar'>
                    {get(item, 'data.label', "")}
                  </Typography>
                  <Typography textProps={{ style: { marginTop: 20 } }} variant='h3'>
                    {get(item, 'cstData.metric_data[0][0]', '--')}
                  </Typography>
                </View>
              );
            }}
            renderFooter={() => (
              <Typography fontWeightType='regular' variant='button'>
                {get(item, 'footerText', "")}
              </Typography>
            )}
          />
        );
      case 'SCORE_BY_SOURCE':
        return <ScoreBySource actionMenuData={getChartExportsMenuItems(item)} item={item} timeperiodLabel={timeperiodLabel} />;
      case 'SENTIMENT_CHART':
        return <SentimentChart item={item} timeperiodLabel={timeperiodLabel} />;
      case 'score_over_time':
        return <ScoreOverTime actionMenuData={getChartExportsMenuItems(item)} item={item} timeperiodLabel={timeperiodLabel} />;
      case 'TOP_BOTTOM_TOPICS':
        return (
          <MultiFeatureCard
            title={get(item, 'title')}
            subTitle={get(item, 'subTitle', '')}
            enableActionBtn={get(item, 'enableActionBtn', false)}
            enableSwitchTab={get(item, 'enableSwitchTab', false)}
            switchOptions={get(item, 'switchOptions', [])}
            renderContent={(activeSwitch, contentRef) => {
              return (
                <ReviewTopicPlot
                  onTopicClick={onTopicClick}
                  type={activeSwitch}
                  widgetData={item}
                  itemData={get(item, 'cstDataV2')}
                  contentRef={contentRef}
                />
              );
            }}
            renderFooter={() => (
              <Typography fontWeightType='regular' variant='button'>
                {item?.footerText}
              </Typography>
            )}
          />
        );
      case 'review_ratings_by_site':
        return <ReviewRatings actionMenuData={getChartExportsMenuItems(item)} item={item} timeperiodLabel={timeperiodLabel} />;
      case 'ONLINE_REVIEW_BY_PROPERTIES':
        return (
          <OnlineReviewByProperties
            lowSampleSize={get(item, 'lowSampleSize')}
            item={{ ...item, subTitle: timeperiodLabel }} />
        );
      default:
        return null;
    }
  }, [timeperiodLabel])

  const renderContent = () => {
    if (isFetchingOnlineReviewData || filtersLoading) {
      return <OverviewLoader />;
    }
    return <GridLayout gap={30} data={OnlineReviewData} renderItem={renderItem} />;
    // return <GridLayout gap={30} data={OVERVIEW_WIDGET_DATA} renderItem={renderItem} />;
  };

  return <View style={{ padding: 20 }}>{renderContent()}</View>;
};
export default OverviewComp;